import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/LegalConsult/Search", params);
};

const getByDocId = (id) => {
  const params = {
    id,
  };

  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/LegalConsult/GetByDocId", params);
};

const getDocumentByDocID = (id) => {
  const params = {
    id,
  };

  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/LegalConsult/GetDocumentByDocID", params);
};

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/LegalConsult/Update?userId=" +
      userData.userId(),
    params
  );
};

export {
  search,
  getByDocId,
  updateItem,
  getDocumentByDocID,
};
